import _ from 'lodash';

export const colorSwatch = (colors, width = 90, height = 20) => {
    const theme = _.isArray(colors) ? colors : [colors];

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');

    _.forEach(theme, (color, i) => {
        ctx.beginPath();
        ctx.rect((i * canvas.width) / theme.length, 0, canvas.width / theme.length, canvas.height);
        ctx.fillStyle = color;
        ctx.fill();
    });

    return canvas.toDataURL('image/png');
};

export default colorSwatch;



// WEBPACK FOOTER //
// ./src/scripts/core/tools/color-swatch.js